import { ContentChildren, Directive, HostBinding, QueryList } from '@angular/core';
import { NgControl } from '@angular/forms';
import { FocusableControlValueAccessor } from '../components/forms/FocusableControlValueAccessor';

@Directive({
  selector: '[opacAutoFocusError]',
})
export class AutoFocusErrorDirective {
  @ContentChildren(NgControl) formControls: QueryList<NgControl>;

  @HostBinding('submit')
  check() {
    const controls = this.formControls.toArray();

    for (const field of controls) {
      if (field.invalid) {
        (field.valueAccessor as FocusableControlValueAccessor).focus();
        return;
      }
    }
  }
}
